var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gaming-pad-alt-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.0001 14.667H13.3334M10.6668 12.0003V17.3337M20.0001 16.0003H20.0134M24.0001 13.3337H24.0134M13.932 6.66699H18.0682C21.568 6.66699 23.3179 6.66699 24.6915 7.33023C25.9008 7.91419 26.9056 8.84977 27.5743 10.0144C28.3337 11.3373 28.4584 13.0827 28.7077 16.5737L29.0358 21.1663C29.1966 23.4182 27.4131 25.3337 25.1555 25.3337C24.001 25.3337 22.9061 24.8208 22.167 23.9339L21.6668 23.3337C21.2092 22.7846 20.9804 22.5101 20.72 22.2883C20.1739 21.8232 19.5128 21.5136 18.8059 21.3918C18.4687 21.3337 18.1114 21.3337 17.3967 21.3337H14.6035C13.8888 21.3337 13.5315 21.3337 13.1943 21.3918C12.4874 21.5136 11.8263 21.8232 11.2802 22.2883C11.0197 22.5101 10.791 22.7846 10.3334 23.3337L9.83322 23.9339C9.09411 24.8208 7.99923 25.3337 6.84471 25.3337C4.58708 25.3337 2.80358 23.4182 2.96443 21.1663L3.29248 16.5737C3.54183 13.0827 3.66651 11.3373 4.42593 10.0144C5.09456 8.84977 6.09936 7.91419 7.30871 7.33023C8.68226 6.66699 10.4322 6.66699 13.932 6.66699Z",
    stroke: "#3370E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameIconActive);
export default __webpack_public_path__ + "static/media/gameIconActive.f46a8379a5c011787f9d2574250791f3.svg";
export { ForwardRef as ReactComponent };